var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.801,
    height: 24.763
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M8.15 4.739h.021a3.315 3.315 0 0 1 3.343 3.283.478.478 0 0 0 .955 0 4.24 4.24 0 0 0-3.3-4.107 5.3 5.3 0 0 1 8.822-1.011.48.48 0 0 0 .531.147 3.4 3.4 0 0 1 1.115-.188 3.315 3.315 0 0 1 3.343 3.283l.478.469a3.283 3.283 0 1 1 0 6.565h-1.91a.469.469 0 1 0 0 .938h1.91a4.217 4.217 0 0 0 .454-8.418 4.273 4.273 0 0 0-4.275-3.775 4.4 4.4 0 0 0-1.116.144A6.266 6.266 0 0 0 8.174 3.801a4.273 4.273 0 0 0-4.271 3.752h-.5a3.283 3.283 0 1 0 0 6.565h16.239a.469.469 0 1 0 0-.938H3.393a2.345 2.345 0 1 1 0-4.689h.955a.473.473 0 0 0 .478-.469A3.315 3.315 0 0 1 8.15 4.739Z",
    "data-name": "Path 262"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m1.096 19.542 1.552-1.552a.388.388 0 0 0-.549-.549L.547 18.993a.388.388 0 1 0 .549.549",
    "data-name": "Path 263"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m4.694 24.649 1.552-1.552a.388.388 0 0 0-.549-.549L4.145 24.1a.388.388 0 1 0 .549.549",
    "data-name": "Path 264"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m5.894 19.542 1.552-1.552a.388.388 0 0 0-.549-.549l-1.552 1.552a.388.388 0 1 0 .549.549",
    "data-name": "Path 265"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m9.492 24.649 1.552-1.552a.388.388 0 0 0-.549-.549L8.943 24.1a.388.388 0 1 0 .549.549",
    "data-name": "Path 266"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m10.692 19.542 1.552-1.552a.388.388 0 0 0-.549-.549l-1.552 1.552a.388.388 0 1 0 .549.549",
    "data-name": "Path 267"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m14.29 24.649 1.552-1.552a.388.388 0 0 0-.549-.549L13.741 24.1a.388.388 0 1 0 .549.549",
    "data-name": "Path 268"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m15.49 19.542 1.552-1.552a.388.388 0 0 0-.549-.549l-1.552 1.552a.388.388 0 1 0 .549.549",
    "data-name": "Path 269"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m19.088 24.649 1.552-1.552a.388.388 0 0 0-.549-.549L18.539 24.1a.388.388 0 1 0 .549.549",
    "data-name": "Path 270"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m20.288 19.542 1.552-1.552a.388.388 0 0 0-.549-.549l-1.552 1.552a.388.388 0 1 0 .549.549",
    "data-name": "Path 271"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43321e",
    fillRule: "evenodd",
    d: "m25.086 19.542 1.552-1.552a.388.388 0 0 0-.549-.549l-1.552 1.552a.388.388 0 1 0 .549.549",
    "data-name": "Path 272"
  }))))));
};
export default SvgCloud;